import { render, staticRenderFns } from "./Township.vue?vue&type=template&id=a1cf3bfc&"
import script from "./Township.vue?vue&type=script&lang=js&"
export * from "./Township.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports